import { render, staticRenderFns } from "./DropDown.vue?vue&type=template&id=e477917e&"
import script from "./DropDown.vue?vue&type=script&lang=js&"
export * from "./DropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e477917e')) {
      api.createRecord('e477917e', component.options)
    } else {
      api.reload('e477917e', component.options)
    }
    module.hot.accept("./DropDown.vue?vue&type=template&id=e477917e&", function () {
      api.rerender('e477917e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/widgets/DropDown.vue"
export default component.exports